import PropTypes from 'prop-types';
import React from 'react';

var LoadingPlaceholder = function LoadingPlaceholder(_ref) {
  var size = _ref.size;
  return React.createElement("svg", {
    width: size,
    height: size
  }, React.createElement("rect", {
    width: size,
    height: size,
    fill: "none"
  }));
};

LoadingPlaceholder.propTypes = {
  size: PropTypes.number
};
export default LoadingPlaceholder;